import { section, color, button } from '@settings/common';

export function Schema() {
  return {
    label: 'Timeline',
    key: 'timeline',
    fields: [
      // ─── Header ─────────────────────────────────────────────────────────────
      {
        label: 'Header',
        name: 'header',
        component: 'group',
        description: 'Super, heading, and optional CTA',
        fields: [
          {
            name: 'showSuper',
            label: 'Show Super',
            component: 'toggle',
            toggleLabels: { true: 'Show', false: 'Hide' },
            defaultValue: true,
          },
          {
            name: 'super',
            label: 'Super Text',
            component: 'text',
            defaultValue: '✦ THE DECADE OF CHILL',
          },
          {
            name: 'superColor',
            label: 'Super Color',
            component: 'select',
            options: color.options,
            defaultValue: color.value.text,
          },
          {
            name: 'showHeading',
            label: 'Show Heading',
            component: 'toggle',
            toggleLabels: { true: 'Show', false: 'Hide' },
            defaultValue: true,
          },
          {
            name: 'heading',
            label: 'Heading',
            component: 'text',
            defaultValue: '10 years. One obsession.',
          },
          {
            name: 'headingColor',
            label: 'Heading Color',
            component: 'select',
            options: color.options,
            defaultValue: color.value.background,
          },
          {
            name: 'cta',
            label: 'CTA (Optional)',
            component: 'link',
            description: 'Displayed at the top right of the component',
          },
          {
            name: 'ctaStyle',
            label: 'CTA Style',
            component: 'select',
            options: [
              { label: 'Lime', value: 'lime' },
              ...button.options.filter(
                (o) => !['link', 'plain', 'customize', 'groupText', 'lionRefer', 'articleLink'].includes(o.value)
              ),
            ],
            defaultValue: 'lime',
          },
          {
            name: 'ctaMobileAlign',
            label: 'CTA Mobile Alignment',
            component: 'select',
            options: [
              { label: 'Left', value: 'left' },
              { label: 'Center', value: 'center' },
            ],
            defaultValue: 'left',
            description: 'Controls alignment of the CTA on mobile (shown below the timeline)',
          },
        ],
        defaultValue: {
          showSuper: true,
          super: '✦ THE DECADE OF CHILL',
          showHeading: true,
          heading: '10 years. One obsession.',
        },
      },

      // ─── Timeline Callouts ──────────────────────────────────────────────────
      {
        name: 'callouts',
        label: 'Timeline Callouts',
        component: 'group-list',
        itemProps: {
          label: '{{item.heading}}',
        },
        defaultItem: {
          date: '2016',
          heading: 'New Milestone',
          copy: 'Describe this milestone here.',
          accentColor: color.value.text,
        },
        fields: [
          {
            name: 'date',
            label: 'Date',
            component: 'text',
            description: 'e.g. 2016, 2018, Q1 2024',
          },
          {
            name: 'heading',
            label: 'Heading',
            component: 'text',
          },
          {
            name: 'copy',
            label: 'Copy',
            component: 'textarea',
          },
          {
            name: 'image',
            label: 'Image (299×168px, 16:9)',
            component: 'image',
            description: 'Use a 299×168px image (16:9 aspect ratio)',
          },
          {
            name: 'accentColor',
            label: 'Accent Color',
            component: 'select',
            description: 'Controls dot, active border, and year label color',
            options: color.options,
            defaultValue: color.value.text,
          },
        ],
        defaultValue: [
          {
            date: '2016',
            heading: 'Founded',
            copy: 'It started with a warm beer and a frustration no product could solve. BrüMate was born out of a Denver garage — built to keep drinks cold, the way they deserve to be.',
          },
          {
            date: '2018',
            heading: 'Hopsulator Launch',
            copy: 'The can cooler that broke the internet. The Hopsulator went viral before "going viral" was the plan — and proved there was a real appetite for premium, insulated drinkware.',
          },
          {
            date: '2020',
            heading: 'Retail Boom',
            copy: 'From DTC to shelves nationwide. BrüMate landed in major retail partners across the country, putting the brand in front of millions of new customers at scale.',
          },
          {
            date: '2022',
            heading: 'BrüTank Drops',
            copy: 'The cooler category, reimagined. BrüTank brought BrüMate\'s obsessive insulation standards to a flagship hard cooler — expanding the brand beyond the cup.',
          },
          {
            date: '2024',
            heading: 'Global Reach',
            copy: 'What started in Denver went global. International markets opened up, bringing BrüMate\'s cold-first philosophy to new audiences around the world.',
          },
          {
            date: '2026',
            heading: '10 Years ✦',
            copy: 'A decade of keeping things cold. From that first garage prototype to a brand recognized worldwide — this is what 10 years of obsession looks like.',
          },
        ],
      },

      // ─── Section Settings ───────────────────────────────────────────────────
      {
        ...section,
        defaultValue: {
          bgColor: '#1a1a1a',
          color: color.value.background,
          desktop: {
            container: 'container',
            mt: 'none',
            py: 'xl',
          },
          mobile: {
            container: 'container',
            mt: 'none',
            py: 'l',
          },
        },
      },
    ],
  };
}
